/*
This file is a copy of dataTables.bootstrap4.js but with additional classes added
for Aurion styling. The factory function was also removed from the original file
because this will only be run in the browser.
*/

'use strict';

export default function addAurionDefaultConfig(DataTable) {

    /* Set the defaults for DataTables initialisation */
    Object.assign(DataTable.defaults, {
        dom:
            "<'row'<'col-xs-12 col-sm-5 col-md-6 col-lg-4 align-items-end d-flex'B><'col-xs-12 col-sm-7 col-md-6 col-lg-4 offset-lg-4'f>>"
            + "<'table-responsive'tr>"
            + "<'row'<'col-xs-12 col-sm-12 col-md-5 col-lg-4'i><'col-xs-12 col-sm-12 col-md-7 col-lg-8'p>>",
        renderer: 'bootstrap',
    });

    /* Default class modification */
    Object.assign(DataTable.ext.classes, {
        container: 'dataTables_wrapper dt-bootstrap5 position-relative',
        search: {
            container: 'dt-search',
            input: 'dt-input form-control form-control-sm',
        },
        length: {
            select: 'custom-select custom-select-sm form-control form-control-sm',
        },
        processing: {
            container: 'dataTables_processing card',
        },
    });

    /* Bootstrap paging button renderer */
    DataTable.ext.renderer.pagingButton.bootstrap = function (
        settings,
        buttonType,
        content,
        active,
        disabled,
    ) {
        // Skip rendering for 'first' and 'last' buttons
        if (buttonType === 'first' || buttonType === 'last') {
            return {};
        }

        const btnClasses = ['dt-paging-button', 'page-item'];

        if (active) {
            btnClasses.push('active');
        }

        if (disabled) {
            btnClasses.push('disabled');
        }

        const li = $('<li>').addClass(btnClasses.join(' '));
        const a = $('<button>', {
            class: 'page-link',
            role: 'link',
            type: 'button',
        })
            .html(content)
            .appendTo(li);

        // Use Font Awesome icons for Previous/Next buttons
        if (buttonType === 'previous') {
            a.html('<i class="fa-light fa-chevron-left"></i>');
        } else if (buttonType === 'next') {
            a.html('<i class="fa-light fa-chevron-right"></i>');
        } else {
            a.html(content);
        }

        return {
            display: li,
            clicker: a,
        };
    };

    DataTable.ext.renderer.pagingContainer.bootstrap = function (settings, buttonEls) {
        return $('<ul/>').addClass('pagination pagination-sm').append(buttonEls);
    };
}
